jQuery(function($){
    if ($('.nav-menu-mobile').length == 0){
        return;
    }


    let $navMenu = $('.nav-menu-mobile');

    $navMenu.find('li.has-sub > a').on('click', function(e){
        e.preventDefault();
        $(this).parent().toggleClass('active');
    });
    
});